import { c as _c } from "react/compiler-runtime";
import { TextExpander } from '@7f-ui/components/text-expander/text-expander';
import type { BeachChairStatus } from '@data-access/graphql/schema.types';
import { Check } from '@phosphor-icons/react';
import type { ReactNode } from 'react';
import { DestinationBreadcrumbs } from 'src/shared/composites/destinations/destination-breadcrumbs';
import { DestinationsHeroMedia } from '../components/destinations-hero-media';
import { DestinationsStatistic } from '../components/destinations-statistic';
import { DestinationsTags } from '../components/destinations-tags';
type DestinationData = {
  name: string;
  slug: string;
  headline: string;
  subline: string;
  teaserText: string;
  readMoreText: string;
  experienceCount?: number;
  accommodationCount?: number;
  beachChairStatus?: BeachChairStatus;
  heroImage?: {
    alt: string;
    url: string;
  } | null;
  tags?: string[];
};
type DestinationProps = {
  data: DestinationData;
  children: ReactNode;
};
export function Destination(t0) {
  const $ = _c(44);
  const {
    data,
    children
  } = t0;
  const t1 = `/reiseziele/${data.slug}`;
  let t2;
  if ($[0] !== data.name || $[1] !== t1) {
    t2 = <DestinationBreadcrumbs links={[{
      label: data.name,
      url: t1
    }]} />;
    $[0] = data.name;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== data.heroImage || $[4] !== data.tags) {
    t3 = <DestinationsHeroMedia image={data.heroImage} tags={data.tags} />;
    $[3] = data.heroImage;
    $[4] = data.tags;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== data.headline) {
    t4 = <h1 className="font-heading1">{data.headline}</h1>;
    $[6] = data.headline;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== data.tags) {
    t5 = data.tags && data.tags.length > 0 && <div className="sm:hidden"><DestinationsTags tags={data.tags} /></div>;
    $[8] = data.tags;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="grid gap-3">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== data.experienceCount) {
    t7 = data.experienceCount !== undefined && data.experienceCount > 0 && <DestinationsStatistic><p className="font-heading4">{data.experienceCount}</p><p className="font-body-small">Erlebnisse</p></DestinationsStatistic>;
    $[13] = data.experienceCount;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== data.accommodationCount) {
    t8 = data.accommodationCount !== undefined && data.accommodationCount > 0 && <DestinationsStatistic><p className="font-heading4">{data.accommodationCount}</p><p className="font-body-small">Unterkünfte</p></DestinationsStatistic>;
    $[15] = data.accommodationCount;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== data.beachChairStatus) {
    t9 = data.beachChairStatus === "beachChairsAvailable" && <DestinationsStatistic><Check weight="bold" className="size-6" /><p className="font-body-small">Strandkörbe</p></DestinationsStatistic>;
    $[17] = data.beachChairStatus;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = <div className="flex gap-4">{t7}{t8}{t9}</div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t3 || $[25] !== t6) {
    t11 = <div className="grid gap-6">{t3}{t6}{t10}</div>;
    $[23] = t10;
    $[24] = t3;
    $[25] = t6;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== data.subline) {
    t12 = <h2 className="font-heading2">{data.subline}</h2>;
    $[27] = data.subline;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== data.teaserText) {
    t13 = <p>{data.teaserText}</p>;
    $[29] = data.teaserText;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== data.readMoreText) {
    t14 = <TextExpander>{data.readMoreText}</TextExpander>;
    $[31] = data.readMoreText;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t12 || $[34] !== t13 || $[35] !== t14) {
    t15 = <div className="fluid-grid"><div className="col-span-full grid gap-4 md:col-span-10">{t12}{t13}{t14}</div></div>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== children || $[38] !== t11 || $[39] !== t15) {
    t16 = <div className="bleed-container gap-y-8 sm:gap-y-16">{t11}{t15}{children}</div>;
    $[37] = children;
    $[38] = t11;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t16 || $[42] !== t2) {
    t17 = <>{t2}{t16}</>;
    $[41] = t16;
    $[42] = t2;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  return t17;
}